import { inject } from "../../../../../lib/itn-ui-kit/services/service-container";

export default function useContractPermissions() {
  const currentUserService = inject("current-user-service");
  const permissions = currentUserService?.userRoles?.permissions ?? [];

  return {
    canAddContract: permissions.includes("entity.add_contract"),
    canEditContract: permissions.includes("entity.change_contract"),
    canDeleteContract: permissions.includes("entity.delete_contract"),
    canViewContract: permissions.includes("entity.view_contract"),
  };
}
